/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Addressbookapiclientid4Inputs */

const en_entity_addressbookapiclientid4 = /** @type {(inputs: Entity_Addressbookapiclientid4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Address Book API Client ID`)
};

const de_entity_addressbookapiclientid4 = /** @type {(inputs: Entity_Addressbookapiclientid4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adressbuch API Client ID`)
};

/**
* | output |
* | --- |
* | "Address Book API Client ID" |
*
* @param {Entity_Addressbookapiclientid4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_addressbookapiclientid4 = /** @type {((inputs?: Entity_Addressbookapiclientid4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Addressbookapiclientid4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_addressbookapiclientid4(inputs)
	return de_entity_addressbookapiclientid4(inputs)
});
export { entity_addressbookapiclientid4 as "entity_addressBookApiClientId" }